// extracted by mini-css-extract-plugin
module.exports = {"disclosuresWrapper":"disclosures_disclosuresWrapper__AEzj8","iconSize":"disclosures_iconSize__XUXr3","disabledHotspot":"disclosures_disabledHotspot__1H8U1"};